import React from "react";
import GenericTable from "./GenericTable";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import { IconButton, Tooltip, Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ClientTable = ({
  clients = [],
  rowCount,
  pageSize,
  page,
  onPageChange,
  onPageSizeChange,
  onSearch,
  onEditClient,
  onDeleteClient,
  onStartConversation,
  isLoading,

  // <<< NOVO
  onDeleteSelected,
  onMergeSelected,
  onSelectionChange,
}) => {
  const { t } = useTranslation("settings");
  const rows = clients.map((client) => {
    const tipoNum =
      typeof client.tipo === "number"
        ? client.tipo
        : Number.isFinite(Number(client.tipo))
        ? Number(client.tipo)
        : null;

    const isPessoaJuridica =
      tipoNum === 1 ||
      (typeof client.tipo === "string" &&
        client.tipo.toLowerCase().includes("jur"));

    const displayName = isPessoaJuridica
      ? client.razao_social ||
        client.razaosocial ||
        client.nome ||
        "N/A"
      : client.nome || "N/A";

    return {
      id: client.id,
      nome: displayName,
      email: client.email || t("shared.notApplicable"),
      cidade: client.cidade || t("shared.notApplicable"),
      uf: client.uf || t("shared.notApplicable"),
      _raw: client,
    };
  });

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "nome", headerName: t("clientTable.colName"), width: 200 },
    { field: "email", headerName: t("shared.email"), width: 300 },
    { field: "cidade", headerName: t("clientTable.colCity"), width: 150 },
    { field: "uf", headerName: t("clientTable.colState"), width: 120 },
    {
      field: "actions",
      headerName: t("clientTable.colActions"),
      width: 250,
      renderCell: (params) => {
        const clientPayload =
          params?.row?._raw ||
          {
            id: params?.row?.id ?? params?.id,
            nome: params?.row?.nome,
            email: params?.row?.email,
            cidade: params?.row?.cidade,
            uf: params?.row?.uf,
          };

        return (
          <Box display="flex" gap={1}>
            <Tooltip title={t("shared.startConversation")}>
              <IconButton
                size="small"
                onClick={() => onStartConversation && onStartConversation(clientPayload)}
              >
                <ChatRoundedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            
            <Tooltip title={t("shared.viewDetails")}>
              <IconButton size="small" component={Link} to={`/clients/${params.id}`}>
                <InfoRoundedIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title={t("shared.edit")}>
              <IconButton
                size="small"
                onClick={() =>
                  onEditClient && onEditClient(params?.row?.id ?? params?.id ?? params?.row)
                }
              >
                <EditRoundedIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title={t("shared.delete")}>
              <IconButton
                size="small"
                onClick={() => onDeleteClient && onDeleteClient(params.row.id)}
              >
                <DeleteOutlineRoundedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  return (
    <GenericTable
      rows={rows}
      columns={columns}
      rowCount={rowCount}
      pageSize={pageSize}
      page={page}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      onSearch={onSearch}
      isLoading={isLoading}
      onExportPDFTitle={t("clientTable.exportTitle")}
      exportFileName="clientes"
      // <<< NOVO: habilita exclusão em massa
      onDeleteSelected={onDeleteSelected}
      onSelectionChange={onSelectionChange}
      bulkActions={({ selectedRows, selectedCount }) => {
        const count = Number(selectedCount) || 0;
        const disabled = count < 2 || count > 5;
        const reason =
          count < 2
            ? "Selecione pelo menos 2 clientes para unificar."
            : count > 5
              ? "Por segurança, a unificação é permitida no máximo para 5 clientes por vez."
              : "";
        const label = `UNIFICAR (${count})`;
        const btn = (
          <Button
            variant="outlined"
            color="primary"
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              onMergeSelected?.(selectedRows);
            }}
            sx={{ textTransform: "uppercase" }}
          >
            {label}
          </Button>
        );
        if (!disabled) return btn;
        return (
          <Tooltip title={reason}>
            <span>{btn}</span>
          </Tooltip>
        );
      }}
      deleteSelectedLabel={t("shared.deleteSelectedTitle")}
      deleteConfirmTitle={t("shared.deleteSelectedTitle")}
      deleteConfirmMessage={(count) => t("shared.deleteSelectedConfirm", { count })}
    />
  );
};

export default ClientTable;
